import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import TextField from '@material-ui/core/TextField';
import styles from '../Contactform.module.scss'
import * as FormAction from '../../../FormAction'

const EnglishForm = (props) => {
	const dispatch = useDispatch()
	const {
		name,
		mobile,
		email,
		description
	} = useSelector(state => state.FormReducer)
	const CHARACTER_LIMIT=150;
	return (
		<div>
			<Grid container spacing={3}>
				<Grid item xs={12} md={12}>
					<TextValidator
						name="name"
						validators={['required']}
						errorMessages={['Incorrect entry.']}
						className={styles.ContactForm}
						id="outlined-helperText"
						label="Full name"
						variant="outlined"
						value={name}
						onChange={(event) => {
							dispatch(FormAction.setContactForm('name', event.target.value))
						}}
					/>
				</Grid>
				<Grid item xs={12} md={6}>
					<TextValidator
						name="mobile"
						validators={['required']}
						errorMessages={['Incorrect entry.']}
						className={styles.ContactForm}
						id="outlined-helperText"
						label="Mobile number"
						variant="outlined"
						value={mobile}
						onChange={(event) => {
							dispatch(FormAction.setContactForm('mobile', event.target.value))
						}}
					/>
				</Grid>
				<Grid item xs={12} md={6} className={styles.Email}>
					<TextValidator
						name="email"
						validators={['required', 'isEmail']}
						errorMessages={['Incorrect entry.']}
						className={styles.ContactForm}
						id="outlined-helperText"
						label="Email address"
						variant="outlined"
						value={email}
						onChange={(event) => {
							dispatch(FormAction.setContactForm('email', event.target.value))
						}}
					/>
				</Grid>
				<Grid item xs={12} md={12}>
					<TextField
						className={styles.ContactForm}
						id="description"
						label="Additional explanations (optional)"
						// placeholder="Additional explanations (optional)"
						multiline
						variant="outlined"
						inputProps={{
							maxlength: CHARACTER_LIMIT
						}}
						helperText={`${description.length}/${CHARACTER_LIMIT}`}
						rows={4}
						value={description}
						onChange={(event) => {
							dispatch(FormAction.setContactForm('description', event.target.value))
						}}
					/>

				</Grid>
			</Grid>
		</div>
	)
}

export default EnglishForm
